// extracted by mini-css-extract-plugin
export default {"links":"Footer_links__sQCGb","social":"Footer_social__3Pk8X"};